import { campaignsAdapter, campaignsSlice } from './';
export var campaignsSelectors = campaignsAdapter.getSelectors(function(state) {
    return state[campaignsSlice.name];
});
